<template>
    <v-container fluid class="superTable pa-0">
        <v-row no-gutters>
          <v-col sm="4">
            <v-text-field
              v-model="search"
              prepend-inner-icon="mdi-magnify"
              :placeholder="$t('modules.courses.table.search.search')"
              outlined
              clearable
              class="superTable__search"
              @click:clear="clearData"
              @keyup.enter="searchAction"
              @keyup.esc="clearData"
            ></v-text-field>
          </v-col>
          <v-col sm="4">
            <Button
              class="ml-4"
              @clicked="searchAction"
              outlined
              depressed
              :text="$t('modules.courses.table.search.search')"
            ></Button>
          </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col sm="12">
                <v-data-table
                    v-model="selectedItems"
                    :totalItems="totalItems"
                    :headers="headers"
                    :items="items"
                    :page.sync="page"
                    :items-per-page="itemsPerPage"
                    hide-default-footer
                    item-key="id"
                    class="superTable__table"
                    style="table-layout: fixed"
                >
                  <template v-slot:item.status="{item}">
                    <v-icon size="12" :color="(item.status) ? 'success' : 'grey lighten-2'">mdi-circle</v-icon>
                  </template>
                  <template v-slot:item.isPaid="{ item }">
                    <v-icon size="12" :color="item.isPaid ? 'success' : 'grey lighten-2'">mdi-circle</v-icon>
                  </template>
                  <template v-slot:item.isMandatory="{ item }">
                    <v-icon size="12" :color="item.isMandatory ? 'success' : 'grey lighten-2'">mdi-circle</v-icon>
                  </template>
                  <template v-slot:item.action="{item}">
                      <v-menu bottom left>
                          <template v-slot:activator="{ on }" v-if="permissions.update || permissions.delete">
                              <v-icon v-on="on" class="superTable__table__item__action">mdi-dots-vertical</v-icon>
                          </template>
                          <v-list class="pa-0">
                              <v-list-item
                                  v-if="permissions.update"
                                  @click="editItem(item.id)"
                              >
                                  <v-list-item-title>
                                      <v-icon>mdi-pencil</v-icon> {{$t('modules.courses.table.search.edit')}}
                                  </v-list-item-title>
                              </v-list-item>
                              <v-list-item
                                  v-if="permissions.delete"
                                  @click="deleteItem(item.id)"
                              >
                                  <v-list-item-title>
                                      <v-icon>mdi-delete</v-icon> {{$t('modules.courses.table.search.delete')}}
                                  </v-list-item-title>
                              </v-list-item>
                          </v-list>
                      </v-menu>
                  </template>
                </v-data-table>
              <v-divider class="mt-4 mb-8"></v-divider>
            </v-col>
        </v-row>
        <v-row no-gutters align="center">
            <v-col sm="3">
                <span class="caption d-inline-block">{{ itemsCount.startItem + ' - ' + itemsCount.endItem + ' de ' + itemsCount.totalItems }}</span>
                <v-select
                    v-model="itemsPerPage"
                    :items="itemsPerPageAvailable"
                    :placeholder="itemsPerPage.toString()"
                    outlined
                    class="superTable__paginationSelect d-inline-block ml-4"
                    @change="$emit('lengthPaginationChange', itemsPerPage)"
                ></v-select>
            </v-col>
            <v-col sm="6" class="text-center">
                <v-pagination v-model="page" :length="pageCount" class="superTable__pagination" @input="$emit('inputPagination', $event)"></v-pagination>
            </v-col>
            <v-col sm="3" align="right">
                <v-text-field
                    v-model="page"
                    max="pageCount"
                    outlined
                    class="superTable__paginationInput d-inline-block mr-4"
                    @keyup.enter="goToPage"
                ></v-text-field>
                <span class="caption d-inline-block">{{$t('modules.courses.table.search.gotopage')}}</span>
            </v-col>
        </v-row>
    </v-container>
</template>

<style lang="sass" scoped>
.v-expansion-panels
    .v-expansion-panel-content
        padding-left: 10px
        padding-bottom: 0px
        padding-right: 16px
</style>

<script>
import Button from '@/components/Button/Button';
export default {
    name: 'SuperTable',
    components: {
      Button
    },
    props: {
        items: Array,
        headers: Array,
        clearSelected: String,
        permissions: {update: false, delete: false},
        pageCount: {
          type: Number,
          default: 1
        },
        page: {
          type: Number,
          default: 1
        },
        totalItems: Number
    },
    data() { return {
        selectedItems: [],
        search: '',
        itemsPerPage: 20,
        itemsPerPageAvailable: [20, 50, 100, 200],
        markedUsers: [],
        gotoPage: this.page,
    }},
    methods:{
      goToPage() {
          const p = Number(this.gotoPage);
          if (
            Number.isInteger(p) &&
            p >= 1 &&
            p <= this.pageCount &&
            p !== this.page
          ) {
            this.$emit('update:page', p);
            this.$emit('inputPagination', p);
          }
        },
        editItem (id) {
            this.$emit('update', id);
        },
        deleteItem (id) {
            this.$emit('delete', id);
        },
        searchAction() {
          if (this.search !== null && this.search !== '') {
            this.$emit('searchAction', this.search);
          } else {
            this.$emit('searchAll');
          }
        },
        clearData() {
          this.search = ''
          this.$emit('searchAll');
        },
        itemsToDelete() {
          this.$emit('bulk-delete', [...this.selectedItems]);
          this.selectedItems = [];
        }
    },
    watch: {
      page(newVal, oldVal) {
    if (newVal !== oldVal) {
      this.gotoPage = newVal;
    }
  }
    },
    computed: {
        areItemsSelected(){
            return !!this.selectedItems.length
        },
        itemsCount() {
          const start = (this.page - 1) * this.itemsPerPage + 1;
          let end = this.page * this.itemsPerPage;

          if (end > this.totalItems) end = this.totalItems;

          return {
            totalItems: this.totalItems,
            startItem: this.totalItems === 0 ? 0 : start,
            endItem: this.totalItems === 0 ? 0 : end
          };
        }
    },
};
</script>
